(function () {
    'use strict';
    angular.module('app').controller('checkout', checkout);
    checkout.$inject = ['$injector','$location', '$scope', '$rootScope', 'gridDataService', '$q', '$timeout', '$mdDialog', 'records', 'command', 'commandService', 'loginService', 'editEmailsService', 'workAreaService', 'zcs', 'selectionCommandService', 'requiredFieldsService', '$filter'];
    function checkout($injector, $location, scope, $rootScope, gridDataService, $q, $timeout, $mdDialog, records, command, commandService, loginService, editEmailsService, workAreaService, zcs, selectionCommandService, requiredFieldsService, $filter) {
        
        // =====================================
        // On Load.
        // =====================================

        // Initialize.
        scope.ACN_SIGN_OUT = 102;
        scope.xyz = { bReadyForOK: false, selectedWorkAreaItem: null, gettingWorkAreaList: true};
        scope.processingLabel = loginService.resourceStrings["PROCESSING"];

        // On click of the command.
        scope.onCheckOutButtonClicked = function (slx) {
            // Ping ACS. On failure, close dialog.
            zcs.Ping(true).then(function (response) {
                // List.
                scope.slx = slx;

                // Dialog config.
                scope.heading = loginService.resourceStrings["TITLE_CHECKOUT"]; 
                scope.workAreaLabel = loginService.resourceStrings["WORK_AREA"];
                scope.filesLabel = loginService.resourceStrings["FILES_TO_CHECKOUT"]; 
                scope.OK = loginService.resourceStrings["OK"]; // "OK";
                scope.Cancel = loginService.resourceStrings["CANCEL"]; // "Cancel";

                // Dialog config columns.
                //scope.doColumns();
                scope.gridOptions.columnDefs = [
                  { name: 'Name', field: 'name', width: '33%', minWidth: '100' },
                  { name: 'Library', field: 'library', width: '33%', minWidth: '100' }];
                var colName = loginService.resourceStrings["SCHEMA_S_LONGNAME"];
                var colLibrary = loginService.resourceStrings["SCHEMA_S_LIBNAME"];
                scope.gridOptions.columnDefs[0].name = colName;
                scope.gridOptions.columnDefs[1].name = colLibrary;

                // For each selection item, add a row to the grid.
                scope.gridOptions.data = [];
                var index = 0;
                angular.forEach(scope.slx.list, function (item) {
                    // Add item.
                    scope.gridOptions.data.push({
                        index: index,
                        selectionItem: item,
                        isSelected: true,
                        name: item.filename, library: item.detailedInfo.libName
                    });
                    index++;
                });

                // Load Work Areas.

                // Create a 'building list' item.
                var workAreaBuildingList = { workAreaId: 'building_list', name: "- " + loginService.resourceStrings["COMBO_BOX_BUILDING_LIST"] + " -" };
                // Add 'building list' to the array.
                scope.workAreaList = [];
                scope.workAreaList.push(workAreaBuildingList);
                // Select 'building list' in the combo.
                scope.xyz.selectedWorkAreaItem = workAreaBuildingList;

                workAreaService.getWorkAreas().then(function (data) {
                    var ValidationState_Valid = 1;
                    data = data.filter(function (workAreaModel) {
                        return workAreaModel.validationState == ValidationState_Valid;
                    });
                    scope.workAreaList = data;
                    if (workAreaService.currentWorkArea != null) {
                        angular.forEach(scope.workAreaList, function (workAreaItem) {
                            if (workAreaItem.workAreaId == workAreaService.currentWorkArea.workAreaId) {
                                scope.xyz.selectedWorkAreaItem = workAreaItem;
                                
                            }
                        });
                    }
                    else {

                    }

                    scope.selectedWorkAreaChanged();
                    scope.xyz.gettingWorkAreaList = false;
                });

                // Enables.
                scope.xyz.bReadyForOK = false;

                // Select rows.
                $timeout(function () {
                    refreshGrid();
                    scope.gridApi.selection.selectAllRows();
                    $timeout(function () {
                        refreshGrid();
                    }, 2000);
                }, 500);

            }, function () {
                // Handle error.
                $mdDialog.hide();
                $rootScope.msgBoxShow(loginService.resourceStrings["ACS_FAILED_TO_CONNECT"], loginService.resourceStrings["ACS_REQUIRED"]);
            });
        };

        // =====================================
        // User interaction.
        // =====================================

        // User picked a work area.
        scope.selectedWorkAreaChanged = function () {
            if (scope.xyz.selectedWorkAreaItem != null) {
                if (scope.xyz.selectedWorkAreaItem.workAreaId == "building_list") {
                    scope.xyz.bReadyForOK = false;
                }
                else {
                    scope.xyz.bReadyForOK = true;
                    workAreaService.currentWorkArea = scope.xyz.selectedWorkAreaItem;
                }
            }
            else {
                scope.xyz.bReadyForOK = false;
            }
            
        }

        // =====================================
        // OK, Cancel.
        // =====================================

        var checkOutItem = function (gridItem) {
            // Each item must be a promise.
            var deferred = $q.defer();

            // Check all files necessary.
            //selectionCommandService.CheckOutVaultCheck(gridItem.selectionItem.detailedInfo.libId, gridItem.selectionItem.fileId, scope.alreadyCheckedArray).then(function (response) {
            selectionCommandService.VaultFileCheck(scope.ACN_SIGN_OUT, gridItem.selectionItem.fileId).then(function (response) {
                zcs.ProcessFileOperationPacket(response.data, true).then(function (response) {
                    if (response != null && response.data != null && response.data.fileOperations != null && response.data.fileOperations.length > 0 && response.data.fileOperations[0].ec != 0) {
                        selectionCommandService.ErrorCode(gridItem.selectionItem, response.data.fileOperations[0].ec).then(function (response) {
                            scope.resultSLX.list.push(response.data);
                            deferred.resolve();
                        }, function (response) {
                            selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
                        });
                    }
                    else {
                        // Execute.
                        // Call the WebApi to do the check-out.
                        selectionCommandService.CheckOutItem(gridItem.selectionItem.fileId, scope.xyz.selectedWorkAreaItem.workAreaId).then(function (response) {
                            // When that  returns, ...
                            var selectionCommandResults = response.data;
                            // Walk the list and add to our results list.
                            angular.forEach(selectionCommandResults.slx.list, function (si) {

                                scope.resultSLX.list.push(si);
                            });
                            // Call ACS to do the file operation.
                            zcs.ProcessFileOperationPacket(selectionCommandResults.fileOperationPacket, true).then(function (response) {
                                var item = $filter('filter')(scope.resultSLX.list, { fileId: gridItem.selectionItem.fileId })[0];

                                requiredFieldsService.currentRecord = item.updateSI;

                                deferred.resolve();
                            }, function (response) {
                                selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
                            });
                        }, function (response) {
                            selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
                        }); // CheckOutItem
                    }
                }, function (response) {
                    selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
                }); // ProcessFileOperationPacket - VaultCheck
            }, function (response) {
                selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
            }); // CheckOutVaultCheck
            // Return the promise for doing the work.
            return deferred.promise;
        };

        // Call back from the dialog.
        var questionBox_PostCloseCallback_Overwrite = function (param1, param2, result) {
            // Remember for next time.
            scope.answers.overwrite = result;
            var gridItem = param1;
            var deferred = param2;
            // If we are to process the item, ...
            if (result == 'Y' || result == 'YtoAll') {
                // Do the work now.
                checkOutItem(gridItem).then(function () {
                    // When that is done, we are done.
                    deferred.resolve();
                }, function () {
                    deferred.resolve(); // Called function will not reject.
                });
            }
            else { // Or if we are not process it, ...
                // Then we are done.
                deferred.resolve();
            }
        }

        // Do one item.
        var doOne = function (list, workNumber) {
            // Each item must be a promise.
            var deferred = $q.defer();
            // Get the item from the grid.
            var gridItem = list[workNumber];

            scope.processingLabel = loginService.resourceStrings["PROCESSING"] + " " + loginService.resourceStrings["FILENAME"] + ": " + gridItem.selectionItem.filename;

            // This dialog has the WorkArea combo be a global. 
            // It is not applied to the row in the grid when it changes.
            var filePNE = scope.xyz.selectedWorkAreaItem.path + "\\" + gridItem.selectionItem.filename;

            // Collision check - local.
            zcs.isFile(filePNE, true).then(function (response) {
                var bExistsLocally = response;
                // Collision check - server.
                //checkOutService.CheckOutCollisionCheck({ filename: gridItem.selectionItem.filename, workAreaId: scope.xyz.selectedWorkAreaItem.workAreaId, bExistsLocally: bExistsLocally }).then(function (response) {
                //    var opFlag = response.data;
                //    var O_DUP = 70; // 'F'; // OPFLAG.O_DUP
                //    var O_NEW = 81; // 'Q'; // OPFLAG._NEW
                //    if (opFlag == O_NEW || opFlag == O_DUP) {
                selectionCommandService.CollisionCheck(scope.ACN_SIGN_OUT, gridItem.selectionItem.fileId, "", "", scope.xyz.selectedWorkAreaItem.workAreaId, bExistsLocally).then(function(response) {
                    var collisionCheckResponse = response.data;
                    if(collisionCheckResponse.bCanOverwrite) {
                        // If YtoAll, then fall through to checkOutItem.
                        if (scope.answers.overwrite != 'YtoAll') {
                            if (scope.answers.overwrite == 'NtoAll') {
                                deferred.resolve();
                                return deferred.promise;
                            }
                            // Ask 'Overwrite?' with Y/N/YtoAll/NtoAll
                            // Use overwrite question - work area.
                            $rootScope.questionBoxShow(gridItem, deferred, gridItem.selectionItem.filename, 
                                loginService.resourceStrings["FILE_EXISTS_IN_WA"], // "File exists in the WorkArea.",
                                loginService.resourceStrings["OVERWRITE_QUESTION_WORKAREA"], // "Overwrite?",
                                questionBox_PostCloseCallback_Overwrite)
                            return deferred.promise;
                        }
                    }
                    checkOutItem(gridItem).then(function () {
                        
                        deferred.resolve();
                    }, function () {
                        deferred.resolve(); // Called function will not reject.
                    });
                }, function (response) {
                    selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
                });
            }, function () {
                selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
            });
            
            // Return the promise for doing the work.
            return deferred.promise;
        }

        // Walk through each item in the grid.
        var doLoop = function (list, workNumber, requiredFieldsData) {
            // Each item must be a promise.
            var deferred = $q.defer();

            var item = list[workNumber];
            var fileId = item.selectionItem.fileId;
            var majRev = item.selectionItem.majRev;
            var minRev = item.selectionItem.minRev;
            // var libraryId = item.selectionItem.libraryId;


            requiredFieldsService.processRecord(item.selectionItem, requiredFieldsData[fileId + majRev + minRev], loginService.resourceStrings["TITLE_CHECKOUT"], 102, false, true).then(function (result) {
                var callUpdateDocument = true;
                switch (result) {
                    case "CANCEL":
                    case "ERROR":
                        //if it's the last item then return, otherwise increase the number to move on to the next item
                        if (workNumber === list.length - 1) {
                            deferred.resolve();
                            return;
                        }
                        else {
                            //skip to the next item;
                            workNumber++;

                            // Recurse on the next item.
                            doLoop(list, workNumber, requiredFieldsData).then(function () {
                                // When that is done. Resolve the promise from before.
                                deferred.resolve();
                            }, function () {
                                deferred.resolve(); // Called function will not reject.
                            });
                            return;
                        }

                        break;
                    case "OK":
                        //continue check-in as normal
                        break;
                    case "CANCELALL":
                        //skip the rest of the items;
                        deferred.resolve();
                        return;
                    default:
                        break;
                }


                var libSettings = requiredFieldsData[fileId + majRev + minRev];
                var updateRequiredFields = false;
                if (libSettings) {
                    updateRequiredFields = $filter('filter')(libSettings.Fields, { Missing: true }).length > 0;
                }
               
                // Do one item.
                doOne(list, workNumber, updateRequiredFields).then(function () {
                    // When that is done, ...
                    // Incement the item number that we are going to work on.
                    workNumber++;

                    if (updateRequiredFields) {
                        
                        requiredFieldsService.updateRecord(null, callUpdateDocument).then(function () {
                            // If we are still in the list, ...
                            if (workNumber < list.length) {
                                // Recurse on the next item.
                                doLoop(list, workNumber, requiredFieldsData).then(function () {
                                    // When that is done. Resolve the promise from before.
                                    deferred.resolve();
                                }, function () {
                                    deferred.resolve(); // Called function will not reject.
                                });
                            }
                            else { // We are done with the list.
                                // Resolve this item.
                                deferred.resolve();
                                // Return the promise.
                                return deferred.promise;
                            }
                        });
                    }
                    else {
                        
                        // If we are still in the list, ...
                        if (workNumber < list.length) {
                            // Recurse on the next item.
                            doLoop(list, workNumber, requiredFieldsData).then(function () {
                                // When that is done. Resolve the promise from before.
                                deferred.resolve();
                            }, function () {
                                deferred.resolve(); // Called function will not reject.
                            });
                        }
                        else { // We are done with the list.
                            // Resolve this item.
                            deferred.resolve();
                            // Return the promise.
                            return deferred.promise;
                        }
                    }


                    
                }, function () {
                    deferred.resolve(); // Called function will not reject.
                });
            });

            // Return the promise for the current item.
            return deferred.promise;
        }
        
        // On click OK.
        scope.onCheckOutDialogOK = function () {
            // Start working.
            scope.xyz.processing = true;
            scope.answers = {};
            scope.answers.overwrite = 'N';
            scope.resultSLX = { mode: 0, order: 0, list: [] };
            scope.alreadyCheckedArray = [];

            // Just use the combo.
            //// All items go to the same work area.
            //// Update the selection item. 
            //angular.forEach(scope.slx.list, function (item) {
            //    item.commandParams = {};
            //    item.commandParams.eWorkAreaId = scope.xyz.selectedWorkAreaItem.workAreaId;
            //});

            //Get required fields info 101 = Check-In
            requiredFieldsService.checkRequiredFields(scope.gridOptions.data, 102).then(function (requiredFieldsData) {
                zcs.isDirectory(scope.xyz.selectedWorkAreaItem.path).then(function (response) {
                    if (!response) {
                        scope.xyz.processing = false;
                        $rootScope.msgBoxShow(loginService.resourceStrings["WORK_AREA_ACCESS"], "");
                        return;
                    }

                    loginService.setLongTermKey().then(function () {
                        // Start the loop.
                        var workNumber = 0;
                        doLoop(scope.gridOptions.data, workNumber, requiredFieldsData).then(function () {
                            // Handle errors.
                            var slx = scope.resultSLX;
                            var atLeastOneError = false;
                            angular.forEach(slx.list, function (item) {
                                if (atLeastOneError == false) {
                                    if (item.ec != 0) {
                                        atLeastOneError = true;
                                        if (atLeastOneError) {
                                            commandService.launchErrors({ slx: slx });
                                            //$rootScope.$broadcast('showErrorList', { slx: response.data });
                                        }
                                    }
                                }
                            });

                            // Close the dialog when finished.
                            $mdDialog.hide();

                            // Done.
                            loginService.removeLongTermToken();
                            scope.xyz.processing = false;
                            gridDataService.updateGridRecords(slx.list);
                        }, function () {
                            loginService.removeLongTermToken();
                            scope.xyz.processing = false;
                        });
                    });

                }, function () {
                    scope.xyz.processing = false;
                });
            }, function () {
                scope.xyz.processing = true;
                $mdDialog.hide();
            });
        };

        // On click Cancel.
        scope.onCheckOutDialogCancel = function () {
            // Close dialog.
            $mdDialog.hide();
        };

        // =====================================
        // Grid.
        // =====================================

        // Called after all rows are selected.
        var refreshGrid = function () {
            scope.gridApi.grid.handleWindowResize();
            scope.gridApi.grid.refreshCanvas();
            scope.gridApi.grid.refresh();
        }

        // Called after the grid has been initialized.
        var onRegisterApi = function (gridApi) {
            scope.gridApi = gridApi;
            gridApi.selection.on.rowSelectionChanged(scope, scope.selectItem);
            gridApi.selection.on.rowSelectionChangedBatch(scope, scope.selectItem);
            switch (command) {
                case "checkout":
                    scope.onCheckOutButtonClicked(records);
                    break;
            }
        }

        scope.gridApi = {};

        scope.gridOptions = {
            data: [],
            enableSelectionBatchEvent: true,
            multiSelect: true,
            modifierKeysToMultiSelect: true,
            enableFullRowSelection: true,
            enableRowHeaderSelection: false,
            useExternalSorting: true,
            enableColumnMenus: false,
            enableColumnResizing: true,
            columnDefs: [
                { name: 'Name', field: 'name', width: '33%', minWidth: '100' },
                { name: 'Library', field: 'library', width: '33%', minWidth: '100' }],
            onRegisterApi: onRegisterApi
        }

        // This was an old way of being called by the toolbar.
        //scope.$on('checkOutButtonClicked', function (event, arg) {
        //    scope.onCheckOutButtonClicked(arg.slx);
        //});

    }
})();
